import { isFinite } from "lodash";
/**
 *
 * @param currentWeight number
 * @param targetWeight number
 * @param initialWeight number,
 * @returns number
 */
export const getProgressValue = (
  currentWeight: number,
  initialWeight: number,
  targetWeight: number
): number => {
  const dividend = currentWeight === 0 ? initialWeight : currentWeight;

  const PERCENTAGE = Math.floor((dividend / targetWeight) * 100);

  if (!isFinite(PERCENTAGE)) return 0;

  return Math.abs(PERCENTAGE);
};
